import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  width: fit-content;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black9};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: -4px 4px 0px 0px ${({ theme }) => theme.colors.black9};
`;

export const TextWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
